export const translation = {
  pl: {
    loading: "Ładowanie",
    languages: {
      pl: "Polski",
      eng: "English",
    },
    noContent: "Brak treści do wyświetlenia.",
    header: "Hodowla Labrador Retriever",
    navBar: {
      mainPage: "Strona Główna",
      aboutUs: "O nas",
      ourDogs: "Nasze psy",
      puppies: "Szczenięta",
      gallery: "Galeria",
      contact: "Kontakt",
    },
    feed: "Aktualności",
    backBtn: "<< Wstecz",
    main: {
      description: (
        <p>
          Witaj na stronie hodowli labrador retriever{" "}
          <span className="breeding-name">HugoNella FCI</span> - w miejscu,
          gdzie pasja łączy się z miłością do psów!
        </p>
      ),

      lowerDescription:
        '"Nasz dom jest pełen merdających ogonów, pocałunków, mokrych nosów i miłości"',
      feedTitle: "Aktualności",
    },
    footer: {
      contactUs: "Skontaktuj się z nami: ",
      phone: "Tel.kom.",
      socialMediaTitle: "Znajdziesz nas również na:",
    },
    aboutUsSection: {
      descriptionOne:
        "Hodowla HugoNella FCI zrodziła się z prawdziwej pasji do psów rasy labrador retriever. Nasza przygoda z hodowlą psów rozpoczęła się w 2015 roku, kiedy w naszym domu pojawiła się Nelka, która od razu skradła nasze serca. Od tamtej pory nasza miłość do tej rasy tylko rosła. Każdy pies jest dla nas wyjątkowy, dlatego dokładamy wszelkich starań, aby zapewnić im jak najlepsze warunki życia i rozwoju",
      descriptionTwo:
        "Nasza pasja opiera się na odpowiedzialnym podejściu do hodowli, dbamy o zdrowie, temperament i socjalizację naszych psów. Labradory to nie tylko piękne psy, ale przede wszystkim wierni towarzysze, którzy obdarzają swoich właścicieli bezwarunkową miłością. Jeśli marzysz o labradorze, który stanie się członkiem Twojej rodziny, serdecznie zapraszamy do kontaktu!",
    },
    ourDogsSection: {
      retiredTitle: "Na emeryturze",
    },
    ourDogDetailsSection: {
      born: "Ur. ",
      parents: "Rodzice: ",
      tests: "Badania: ",
      checkLineageBtn: "Sprawdź rodowód",
      showsBtn: "Wystawy",
      galleryBtn: "Galeria",
    },
    dogShows: {
      showMainTitle: "Wystawy",
      place: "Miejsce: ",
      date: "Data: ",
      judge: "Sędzia: ",
      rate: "Ocena: ",
    },
    puppiesSection: {
      plannedLitters: "Planowane mioty",
      currentLitters: "Aktualne mioty",
      previousLitters: "Poprzednie mioty",
      mother: "Matka",
      father: "Ojciec",
    },
    plannedLittersSection: {
      title: "Planowane mioty",
      lackOfLitters: "W tym momencie brak planowanych miotów",
    },
    currentLittersSection: {
      title: "Aktualne mioty",
      lackOfLitters: "W tym momencie brak aktualnych miotów.",
    },
    previousLittersSection: {
      title: "Poprzednie mioty",
    },
    gallerySection: {
      shows: "Wystawy",
      dailyLife: "Życie codzienne",
    },
    contactSection: {
      contactTitle: "Hodowla Hugonella FCI",
      owners: "Kinga i Paweł Katarzyńscy",
      findUs: "Znajdziesz nas w:",
      breedingPlace: "Gaj, Wielkopolskie",
      contactUs: "Skontaktuj się z nami:",
      contactTel: "Tel.kom.",
      messageUs: "Napisz do nas:",
    },
    littersSection: {
      mother: "Matka: ",
      father: "Ojciec: ",
      noPlannedLitters: "W tym momencie brak planowanych miotów",
      noCurrentLitters: "W tym momencie brak aktualnych miotów",
      noLitters: "Brak miotów do wyświetlenia",
    },
  },
  en: {
    loading: "Ładowanie",
    languages: {
      pl: "Polski",
      eng: "English",
    },
    noContent: "No content to display.",
    header: "Labrador Retriever Kennel",
    navBar: {
      mainPage: "Home Page",
      aboutUs: "About us",
      ourDogs: "Our dogs",
      puppies: "Puppies",
      gallery: "Gallery",
      contact: "Contact",
    },
    feed: "News",
    backBtn: "<< Back",
    main: {
      description: (
        <p>
          Welcome to the website of the{" "}
          <span className="breeding-name">HugoNella FCI</span> Labrador
          Retriever kennel - a place where passion combines with love for dogs!
        </p>
      ),

      lowerDescription:
        '"Our home is full of wagging tails, kisses, wet noses and love"',
      feedTitle: "News",
    },
    footer: {
      contactUs: "Contact us: ",
      phone: "Phone number: ",
      socialMediaTitle: "You can also find us on:",
    },
    aboutUsSection: {
      descriptionOne:
        "HugoNella FCI kennel was born out of a true passion for Labrador Retrievers. Our adventure with dog breeding began in 2015, when Nelka appeared in our home and immediately stole our hearts. Since then, our love for this breed has only grown. Every dog ​​is unique to us, which is why we make every effort to provide them with the best possible living and development conditions",

      descriptionTwo:
        "Our passion is based on a responsible approach to breeding, we care about the health, temperament and socialization of our dogs. Labradors are not only beautiful dogs, but above all faithful companions who give their owners unconditional love. If you dream of a Labrador that will become a member of your family, we invite you to contact us!",
    },
    ourDogsSection: {
      retiredTitle: "Retired",
    },
    ourDogDetailsSection: {
      born: "Born: ",
      parents: "Parents: ",
      tests: "Tests: ",
      checkLineageBtn: "Check the pedigree",
      showsBtn: "Shows",
      galleryBtn: "Gallery",
    },
    dogShows: {
      showMainTitle: "Shows",
      place: "Place: ",
      date: "Date: ",
      judge: "Judge: ",
      rate: "Rate: ",
    },
    puppiesSection: {
      plannedLitters: "Planned litters",
      currentLitters: "Current litters",
      previousLitters: "Previous litters",
      mother: "Mother",
      father: "Father",
    },
    plannedLittersSection: {
      title: "Planned litters",
      lackOfLitters: "There are no planned litters at this time.",
    },
    currentLittersSection: {
      title: "Current litters",
      lackOfLitters: "There are no current litters at this time.",
    },
    previousLittersSection: {
      title: "Previous litters",
    },
    gallerySection: {
      shows: "Shows",
      dailyLife: "Daily life",
    },
    contactSection: {
      contactTitle: "Hugonella FCI Kennel",
      owners: "Kinga and Paweł Katarzyńscy",
      findUs: "You can find us in:",
      breedingPlace: "Gaj, Greater Poland",
      contactUs: "Contact us:",
      contactTel: "Phone number: ",
      messageUs: "Write to us: ",
    },
    littersSection: {
      mother: "Mother: ",
      father: "Father: ",
      noPlannedLitters: "There are no planned litters at this time",
      noCurrentLitters: "There are no current litters at this time",
      noLitters: "No litters to display",
    },
  },
};
